import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  Outlet,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import App from "./App";
import PrivateRoute from "./helper/PrivateRoute";
import "./index.css";
import axios from "axios";
import Dashboard from "./pages/Dashboard/Dashboard";
import Settings from "./pages/Settings/Settings";
import NotFound from "./pages/Notfound/NotFound";
import { AuthPage } from "./pages/AuthPages/AuthPage";
import Overview from "./pages/Shop/Overview";
import FrontPage from "./pages/Shop/FrontPage";
import Category from "./pages/Shop/Category";
import Product from "./pages/Shop/Product";
import Products from "./pages/Products/Products";
import NewProduct from "./pages/Products/NewProduct";
import EditProduct from "./pages/Products/EditProduct";
import Bill from "./pages/Settings/Bill";
import OrderDetail from "./pages/Orders/OrderDetail";
import Orders from "./pages/Orders/Orders";
import Register from "./pages/AuthPages/Register";
import Invoice from "./helper/Invoice";
import AGB from "./pages/legalPages/AGB";
import Legal from "./pages/legalPages/Legal";
import { VerifyEmail } from "./pages/AuthPages/ForgetPassword/VerifyEmail";
import ResetPassword from "./pages/AuthPages/ForgetPassword/ResetPassword";

axios.defaults.withCredentials = true;
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename="/beta/app">
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <App />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate replace to="/shop" />} />
        <Route path="settings">
          <Route
            index
            element={
              <PrivateRoute role="User">
                <Settings />
              </PrivateRoute>
            }
          />
          <Route path="bill">
            <Route
              path="pdf"
              element={
                <PrivateRoute role="User">
                  <Invoice />
                </PrivateRoute>
              }
            />
            <Route
              path=":query"
              element={
                <PrivateRoute role="User">
                  <Bill />
                </PrivateRoute>
              }
            />
          </Route>
        </Route>
        <Route path="orders">
          <Route
            index
            element={
              <PrivateRoute role="User">
                <Orders />
              </PrivateRoute>
            }
          />
          <Route path="details">
            <Route
              path=":id"
              element={
                <PrivateRoute role="User">
                  <OrderDetail />
                </PrivateRoute>
              }
            />
          </Route>
        </Route>
        <Route path="listings">
          <Route
            index
            element={
              <PrivateRoute role="User">
                <Products />
              </PrivateRoute>
            }
          />
          <Route
            path="new"
            element={
              <PrivateRoute role="User">
                <NewProduct />
              </PrivateRoute>
            }
          />
          <Route path="edit">
            <Route
              path=":id"
              element={
                <PrivateRoute role="User">
                  <EditProduct />
                </PrivateRoute>
              }
            />
          </Route>
        </Route>
        <Route path="shop">
          <Route path="product" element={<Outlet />}>
            <Route
              path=":productID"
              element={
                <PrivateRoute role="User">
                  <Product />
                </PrivateRoute>
              }
            />
          </Route>
          <Route
            index
            element={
              <PrivateRoute role="User">
                <FrontPage />
              </PrivateRoute>
            }
          />
          <Route
            path=":catalogue"
            element={
              <PrivateRoute role="User">
                <Category />
              </PrivateRoute>
            }
          />
        </Route>
      </Route>
      <Route path="*" element={<NotFound />} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/forgotPassword" element={<VerifyEmail />} />
      <Route path="/resetPassword" element={<ResetPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/agb" element={<AGB />} />
      <Route path="/legal" element={<Legal />} />
    </Routes>
  </BrowserRouter>
);
